import React, { Component } from 'react';
import PolicyForm from './PolicyForm';
import NavBar from '../NavBar/NavBar';
import './Policy.css';


class Policy extends Component {
  render () {
    return (
      <div className="PolicyPage">
        <NavBar showLess={!localStorage.getItem("y_jwt_token")} />
        <PolicyForm />
      </div>
    )
  }
}

export default Policy;



// WEBPACK FOOTER //
// ./src/components/Policy/Policy.js